import React, { Component } from "react";
import {
  getAllEntries,
  update,
  updateAll,
  save,
  deletePassport,
} from "../../services/passportInOutService";

import { getAccountCompany } from "../../services/visaService";

import {
  Table,
  Grid,
  Icon,
  Confirm,
  Button,
  Label,
  Statistic,
} from "semantic-ui-react";
import auth from "../../services/authService";
import { toast } from "react-toastify";
import BlockUi from "react-block-ui";
import { Link } from "react-router-dom";
import TableTitle from "../common/tableTitle";
import Form from "../common/form";
import Joi from "joi-browser";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import queryString from "query-string";

class InOutDetail extends Form {
  state = {
    open: false,
    visa: {},
    visa_id: "",
    entries: [],
    companyId: "",

    paymentDate: new Date(),
    ledgerTypes: [
      { id: "1", name: "In" },
      { id: "2", name: "Out" },
    ],
    ledgerType: 1,
    data: {
      description: "",
    },
    errors: {},
    ledgerTypeName: "In",
  };

  schema = {
    id: Joi.string(),
    description: Joi.string().required().label("Description"),
  };

  async getCompanyId(visaId) {
    try {
      this.setState({ blocking: true });

      let companyId = await getAccountCompany(visaId);

      this.setState({
        companyId: companyId.data,
        visa_id: visaId,
        blocking: false,
      });
    } catch (ex) {
      if (ex.response && ex.response.status === 404)
        this.props.history.replace("/not-found");
    }
  }

  async loadEntries() {
    const visaId = this.props.match.params.id;

    await this.getCompanyId(visaId);

    const { data: entries } = await getAllEntries(visaId);

    this.setState({ blocking: false, entries });
  }

  componentDidMount() {
    this.loadEntries();
  }

  handleDeleteLedger = (type) => {
    this.setState({ openLedger: true, type });
  };

  handleChangePaymentDate = (date) => {
    this.setState({
      paymentDate: date,
    });
  };

  doSubmit = async () => {
    try {
      this.setState({ blocking: true });
      const data = { ...this.state.data };

      var event = new Date(this.state.paymentDate);
      let date = JSON.stringify(event);
      date = date.slice(1, 11);
      data.inout_date = date;

      data.in_out_status = this.state.ledgerType;
      data.visa_id = this.state.visa_id;

      await save(data);

      toast.success("Entry has been added successfully.");
      this.setState({
        blocking: false,
        ledgerType: 1,
        ledgerTypeName: "",
        data: { description: "" },
      });

      this.loadEntries();
    } catch (ex) {
      console.log(ex.response);
      if (ex.response && ex.response.status === 422) {
        const errors = { ...this.state.errors };

        if (ex.response.data.errors.payment)
          errors.payment = ex.response.data.errors.payment;

        this.setState({ errors, blocking: false });
        //toast.warning("check validation errors.");
      }
    }
  };

  updateLedgerType = (ledgerType, ledgerTypeName) => {
    this.setState({ ledgerType, ledgerTypeName });
  };

  handleCancelLedger = () => {
    this.setState({ openLedger: false });
  };

  handleUpdateLedger = (type) => {
    return this.props.history.replace("/visas-ledgers/" + type.id + "/edit");
  };

  doDeleteLedger = async () => {
    const type = this.state.type;
    const originalTypes = this.state.payments;
    const payments = originalTypes.filter((o) => o.id !== type.id);
    this.setState({ payments, openLedger: false });

    try {
      await deletePassport(type.id);

      toast.success("Entry has been deleted successfully.");
    } catch (ex) {
      if (ex.response && ex.response.status === 404) {
        toast.success("This Entry has already been deleted.");
      }

      this.setState({ types: originalTypes });
    }
  };

  render() {
    const { visa } = this.state;
    const { keyword, status } = queryString.parse(this.props.location.search);

    return (
      <BlockUi tag="div" blocking={this.state.blocking}>
        <Confirm
          open={this.state.openLedger}
          header="Confirmation"
          content="Are you sure, you want to delete the record?"
          onCancel={this.handleCancelLedger}
          onConfirm={this.doDeleteLedger}
          size="mini"
        />

        <h1 className="container__heading">Passport In Out Detail</h1>
        <Link
          to={`/visas-accounts?keyword=${keyword}&status=${status}`}
          className="btn btn--secondary"
          style={{ display: "inline-block" }}
        >
          Back
        </Link>
        <Table celled fixed singleLine style={{ marginTop: 0 }}>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell width={2}>Date</Table.HeaderCell>
              <Table.HeaderCell width={9}>Description</Table.HeaderCell>
              <Table.HeaderCell width={3}>Status</Table.HeaderCell>
              <Table.HeaderCell width={2}></Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>
            {this.state.entries.map((entry) => (
              <Table.Row>
                <Table.Cell style={{ textAlign: "center" }}>
                  {entry.inout_date}
                </Table.Cell>
                <Table.Cell>
                  <div style={{ whiteSpace: "pre-line" }}>
                    {entry.description}
                  </div>
                </Table.Cell>
                <Table.Cell>
                  <div style={{ whiteSpace: "pre-line" }}>
                    {entry.in_out_status == 1 ? (
                      <Label color="green">In</Label>
                    ) : (
                      <Label color="red">Out</Label>
                    )}
                  </div>
                </Table.Cell>
                <Table.Cell>
                  {auth.getCurrentUser().email ===
                    "company-unblocker@gondalgroup.ae" && (
                    <div>
                      <Icon
                        name="trash"
                        color="red"
                        className="clickable"
                        onClick={() => this.handleDeleteLedger(entry)}
                      />

                      {/* <Icon
                          name="edit"
                          color="blue"
                          className="clickable"
                          onClick={() => this.handleUpdateLedger(entry)}
                        /> */}
                    </div>
                  )}
                </Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>

        <form
          onSubmit={this.handleSubmit}
          style={{ width: "50%", marign: "auto" }}
        >
          <div className="card form">
            <div className="form__content">
              <h3 className="card__heading">Passport In/Out</h3>
              <p>Provide the passort information below.</p>
            </div>
            <br />
            <Button.Group>
              {this.state.ledgerTypes.map((type) => (
                <React.Fragment>
                  <Button
                    positive={
                      this.state.ledgerTypeName === type.name ? true : false
                    }
                    onClick={() => this.updateLedgerType(type.id, type.name)}
                  >
                    {type.name}
                  </Button>
                </React.Fragment>
              ))}
              ;
            </Button.Group>
            <br />
            <br />
            {this.renderInput("description", "Description", "text")}
            <label>
              <b>In Out Date</b>
            </label>
            <br />
            <DatePicker
              className="input"
              selected={this.state.paymentDate}
              onChange={this.handleChangePaymentDate}
            />
            {this.renderButton("Add")}
          </div>
        </form>
        <br />
      </BlockUi>
    );
  }
}

export default InOutDetail;
